export function returnReserveSubtitle(
  reserve,
  features,
  displayedOnDashboard = false
) {
  const stringParts = [];

  if (reserve?.tour_key) {
    if (features?.OTHERS?.BACKOFFICE?.tourNumberOnlyLastDigit) {
      stringParts.push(`Tour ${reserve.tour_key.slice(-1)}`);
    } else {
      stringParts.push(`Tour ${reserve.tour_key}`);
    }
  }

  if (reserve?.vehicle_key) {
    stringParts.push(`Camion ${reserve.vehicle_key}`);
  }

  if (reserve?.driver?.fullname) {
    stringParts.push(`Chauffeur ${reserve?.driver?.fullname}`);
  }

  if (reserve?.photos_count && !displayedOnDashboard) {
    let reserveStringPart = `${reserve?.photos_count}`;
    if (reserve?.photos_count.length > 1) {
      reserveStringPart += ' pièces jointes';
    } else {
      reserveStringPart += ' pièce jointe';
    }

    stringParts.push(reserveStringPart);
  }

  return stringParts.join(' • ');
}
